
import { Injectable } from '@angular/core';
import { Action } from '../../../section/master/model/action';
import { ContactUs,Subscription } from '../model/contact-us';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class ContactUsService {
    http:HttpClientService;
    cookie : CookiesService;
    objAction : Action; 
    profilePic  : any[];
    constructor(http : HttpClientService, cook : CookiesService) {
       this.http = http;
       this.cookie = cook;
       this.objAction  = new Action(this.http,  this.cookie);
    }
     
    getSubscription() :   Observable<Subscription[]> {
      this.objAction.path = 'api/ClientReview/GetSubscriptions';
      return this.objAction.get();
    }

    getDoctorSubscription() :   Observable<Subscription[]> {
      this.objAction.path = 'api/Users/GetDoctorSubscriptions';
      return this.objAction.get();
    }

      getContactUS() :   Observable<ContactUs[]> {
        this.objAction.path = 'api/ContactUs/GetContactUs';
        return this.objAction.get();
      }
      getCorporateQuery() :   Observable<ContactUs[]> {
        this.objAction.path = 'api/ContactUs/GetCorporateQuery';
        return this.objAction.get();
      }

      getInvoiceForOrderId(id: string) :   Observable<any> {
        this.objAction.path = 'api/Users/GetDoctorSubscriptionsInvoice/'+id;
        return this.objAction.get();
      }
    
    DeleteContactUs(id: number) : Observable<any> {
      this.objAction.header = null;
      this.objAction.path = 'api/ContactUs/DeleteContact?ContactId='+id; 
      return this.objAction.delete();
    }
    deleteCorporateQuery(id: number) : Observable<any> {
      this.objAction.header = null;
      this.objAction.path = 'api/ContactUs/DeleteCorporateQuery?QueryId='+id; 
      return this.objAction.delete();
    }

    deleteSubscription(id: number) : Observable<any> {
      this.objAction.header = null;
      this.objAction.path = 'api/ClientReview/DeleteSubscription?id='+id; 
      return this.objAction.delete();
    }
    unscubscribe(id: number) : Observable<any> {
      this.objAction.header = null;
      this.objAction.path = 'api/Users/Unsubscribe?id='+id; 
      return this.objAction.delete();
    }
 
  }



// WEBPACK FOOTER //
// ./src/app/section/user/service/contact-us.service.ts